import { render, staticRenderFns } from "./sysDistributor.vue?vue&type=template&id=2a24bfc6&scoped=true&"
import script from "./sysDistributor.vue?vue&type=script&lang=js&"
export * from "./sysDistributor.vue?vue&type=script&lang=js&"
import style0 from "./sysDistributor.vue?vue&type=style&index=0&id=2a24bfc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a24bfc6",
  null
  
)

component.options.__file = "sysDistributor.vue"
export default component.exports